<template>
  <modal name="productDetailPopup" :width="850" :height="780" :clickToClose="false"
      @before-open="beforeOpen"
      @opened="opened">
    <div id="div_productDetailPopup" class="popup on">
      <div class="pop_tit">
        상품상세
      </div>
      <div class="pop_con_wrap">
        <div id="div_productDetailPopupScroll" class="scroll_area" style="height: 600px;">
          <div class="pop_con_bg">
            <!-- Swiper -->
            <div class="tbl_title">
              <h2>상품정보</h2>
            </div>
            <div class="board_list type02">
              <table class="board_table">
                <caption class="hide">상품주문 조회 테이블</caption>
                <colgroup>
                  <col style="width:20%">
                  <col style="width:20%">
                  <col style="width:">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">제조사</th>
                    <th scope="col">상품코드</th>
                    <th scope="col">상품명</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="wbg">{{product.brandName}}</td>
                    <td class="wbg">{{product.brandProductId}}</td>
                    <td class="wbg">{{product.productName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--  -->
            <div class="img_wrap">
              <div class="img_delete"  v-if="bigImageFileNo > 0 && roleLevel <= USER_AUTH.MANAGER">
                <div class="btn_area">
                  <a class="button white" @click="deleteImage"><span>이미지 삭제</span></a>
                </div>
              </div>

              <div class="swiper-container gallery-top mt20"  v-if="bigImageFileNo > 0">  
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <a href="javascript:void(0)" class="swiper-con">
                      <p><span class="img"><img :src="imageUrl + bigImageFileNo" /></span></p>
                    </a>
                  </div>
                </div>
              </div>    

              <div class="swiper-container  gallery-thumbs speSwiper mt20 ">

                <div class="swiper-wrapper">

                <swiper :options="swiperOption" ref="productImageSwiper">

                  <div class="swiper-slide" v-for="image in product.imageList" v-bind:key="image.imageFileNo">
                    <a href="javascript:void(0)" class="swiper-con" @click="setBigImage(image.imageFileNo)">
                      <p><span class="img"><img :src="imageUrl + image.imageFileNo" /></span></p>
                    </a>
                  </div>


                  <div class="swiper-slide">
                    <input type="file" id="imageFile" accept=".gif, .jpg, .png" class="image_file" @change="addImage" />
                    <a href="javascript:void(0)" class="swiper-con" @click="openFile">
                      <p><span class="img"><img src="@/assets/images/complus_big.jpg" /></span></p>
                    </a>
                  </div>

                  <div class="swiper-slide" v-for="i in noimgSize" v-bind:key="i">
                    <a href="javascript:void(0)" class="swiper-con">
                      <p><span class="noimg"></span></p>
                    </a>
                  </div>

                  </swiper>

                  <!-- <div class="swiper-pagination"></div> -->
                  <div class="swiper-button-prev" @click="slidePrev"></div>
                  <div class="swiper-button-next" @click="slideNext"></div>
                </div>
              </div>

            </div>
            <!--  -->
            <div class="tbl_title mt20">
              <h2>제원보기</h2>
              <div class="board_list type02 data_view">
                <table class="board_table">
                  <caption class="hide">상품주문 조회 테이블</caption>
                  <colgroup>
                    <col style="width:20%">
                    <col style="width:">
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">구분</th>
                      <th scope="col">설명</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ERP 코드</td>
                      <td>{{product.erpProductId}}</td>
                    </tr>
                    <tr>
                      <td>ERP 상품명</td>
                      <td>AMBANOL 5W30 롱라이프 LL (BOX)</td>
                    </tr>
                    <tr>
                      <td>Fitting Position</td>
                      <td>Lower Front Axle, Outer, Right</td>
                    </tr>
                    <tr>
                      <td>Cone Pitch</td>
                      <td>1.5</td>
                    </tr>
                    <tr>
                      <td>Cone Size [mm]</td>
                      <td>9.5</td>
                    </tr>
                    <tr>
                      <td>Driver Position </td>
                      <td>For left/right-hand traffic</td>
                    </tr>
                    <tr>
                      <td>Raired article n..</td>
                      <td>JbJ751</td>
                    </tr>
                    <tr>
                      <td>Supplenentar</td>
                      <td>Whit accessories</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="tbl_title mt20">
              <div class="model_text">
                <span>참고사항</span>
                <p class="mt0" v-if="product.memo != null && product.memo != ''">{{product.updateDt}} /  [{{product.updateUserPartnerName}}] / {{product.updateUserName}}</p>
              </div>
              <div class="model_con">
              <textarea id="productDetailMemo" cols="100" rows="8" v-text="product.memo"></textarea>
              </div>
              <div class="model_footer">
                <div class="btn_area mt0" v-if="roleLevel <= USER_AUTH.MANAGER">
                  <a href="javascript:void(0)" class="button white" @click="updateMemo"><span>저장(수정)</span></a>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
      <div class="pop_footer_wrap">
        <div class="btn_area mt0">
          <a href="javascript:void(0);" class="button dark" @click="close"><span>닫기</span></a>
        </div>
      </div>
      <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
    </div>
  </modal>  
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'productDetailPopup',
  props: {
    value : ''
  },
  data () {
    return {
      USER_AUTH : AppConfig.USER_AUTH,
      productNo : 0,
      noimgSize : 1,
      bigImageFileNo : 0,
      swiperOption : {
        paginationClickable: false,
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 10,
        observer: true,
        observeParents: true
      },
      product : {}
    }
  },
  mounted () {
    
  },
  computed: {
    imageUrl () {
      return AppConfig.HTTP_CONFIG.baseURL + '/common/image?xAuthToken=' + window.$store.getters['Login/getToken'] + '&imageFileNo='
    },
    token () {
      return window.$store.getters['Login/getToken']
    },
    roleLevel () {
      return window.$store.getters['Login/getRoleLevel']
    }
  },
  methods: {
    beforeOpen(e) {
      this.productNo = 0;
      this.noimgSize = 1;
      this.bigImageFileNo = 0;
      this.product  = {};
      var productNo = e.params.productNo;

      if (productNo != null && productNo != '') {
        this.productNo = productNo;
      }       
    },
    opened(e) {
      Vue.httpClient
      .get('/common/product/detail', { params : { productNo : this.productNo }})
      .then((response) => {
        if ( response.data.result ) {
          this.product   = response.data.result;
          this.noimgSize = (this.product.imageList.length >= 6) ? 1 : 6 - this.product.imageList.length;

          if ( this.product.imageList != null && this.product.imageList.length > 0 ) {
            this.bigImageFileNo = this.product.imageList[0].imageFileNo;
          }
        } 
      });

      // content scroll
      $("#div_productDetailPopupScroll").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
      });

      // close button
      $("#div_productDetailPopup").parent().css('overflow', 'visible');
    },
    close() {
      this.$modal.hide('productDetailPopup');
    },
    slidePrev() {
      this.$refs.productImageSwiper.swiper.slidePrev();
    },    
    slideNext() {
      this.$refs.productImageSwiper.swiper.slideNext();
    },
    updateMemo() {
      // 참고사항 수정
      window.$Alert.confirm('참고사항을 수정하시겠습니까?')
      .then((result) => {      
        if (!result) { return; }
          Vue.httpClient
          .post('/common/product/memo/update', {
            productNo : this.productNo,
            memo : $('#productDetailMemo').val()
          })
          .then((result) => {
            if (result.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
              window.$Alert.alert('참고사항 수정이 완료되었습니다.');
            }
          })
      });

    },
    openFile() {
      var ele_file = document.getElementById('imageFile');
      ele_file.click();
    },
    addImage(event) {
      var file = event.target.files[0];
      var ext  = file.name.substring(file.name.length, file.name.length-3).toLowerCase();

      // 파일 확장자 체크
      if ( ext != 'gif' && ext != 'jpg' && ext != 'png' ) {
        window.$Alert.alert('이미지파일(gif, jpg, png)만 업로드 가능합니다.');
        return;
      }

      var frm = new FormData();
      frm.append("file", event.target.files[0]);
      frm.append("imageGroupNo", this.product.imageGroupNo);
      frm.append("imageTypeCode", AppConfig.IMAGE_TYPE.PRODUCT);
      frm.append("pkNo", this.productNo);

      Vue.httpClient
        .post('/common/image/upload', frm, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          if ( this.product.imageGroupNo == null || this.product.imageGroupNo <= 0 ) {
            this.product.imageGroupNo = response.data.result.imageGroupNo;
          }
          
          this.product.imageList.push(response.data.result);
        });       
        
    },
    setBigImage(imageFileNo) {
      this.bigImageFileNo = imageFileNo;
    },
    deleteImage() {
      window.$Alert.confirm('해당 이미지를 삭제하시겠습니까?')
      .then((result) => {      
        if (!result) { return; }

        Vue.httpClient
        .get('/common/image/delete', { params : { imageFileNo : this.bigImageFileNo }})
        .then((response) => {
          if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
            if ( this.product.imageList != null && this.product.imageList.length > 0 ) {
              var deleteIndex = 0;

              for (var i in this.product.imageList) {
                if ( this.product.imageList[i].imageFileNo == this.bigImageFileNo ) {
                  deleteIndex = i;
                  break;
                }
              }

              this.product.imageList.splice(deleteIndex, 1);              

              if ( this.product.imageList.length > 0 ) {
                this.bigImageFileNo = this.product.imageList[0].imageFileNo;
              }
            }

            window.$Alert.alert('이미지 삭제에 성공하였습니다.');
          } 
        });        
      });
    }
  }
}
</script>

<style scoped>
.image_file {
  position: absolute; 
  width: 1px; 
  height: 1px; 
  padding: 0; 
  margin: -1px; 
  overflow: hidden; 
  clip:rect(0,0,0,0); border: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/common/ProductDetailPopup.vue